import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ChannelEmailConfigResponse, UpdateChannelEmailConfigRequest } from '@/modules/channels/types';
import { channelsApi } from '../services';

/**
 * PATCH /channels/:id/email-config — grava apenas os campos alterados
 * (merge por campo no backend). Ao concluir, invalida tanto a config de
 * e-mail dedicada quanto o canal (`ChannelResponse.config` espelha os
 * mesmos campos e alimenta outras seções da tela de edição).
 */
export const useUpdateChannelEmailConfig = (channelId: string) => {
  const queryClient = useQueryClient();
  return useMutation<ChannelEmailConfigResponse, Error, UpdateChannelEmailConfigRequest>({
    mutationFn: (body) => channelsApi.updateEmailConfig(channelId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['channels', channelId, 'email-config'] });
      queryClient.invalidateQueries({ queryKey: ['channels', channelId] });
    },
  });
};
